export const MetricsOverview = [
  {
    title: 'Active shops',
    code: 'active_shops',
    value: 0,
  },
  {
    title: 'High rating shops (≥3.0)',
    code: 'high_rating',
    value: 0,
  },
  {
    title: 'New shops in this month',
    code: 'new_shops',
    value: 0,
  },
  {
    title: 'Total active SKU',
    code: 'activated_skus',
    value: 0,
  },
  {
    title: 'Selling SKU rate',
    code: 'per_selling_skus',
    value: 0,
  },
];

export enum RegionCode {
  VN = 'vn',
  USA = 'usa',
}
